export { default } from './PartiuGpInglaterra';
